import React, { ReactElement } from "react";
import { Text } from "web/react/emo/text";

export function LabelledRow({
    label,
    value,
}: {
    label: string;
    value: React.ReactNode;
}): ReactElement {
    return (
        <Text as="p" textStyle="body-s">
            <Text as="span" textStyle="body-s" color="secondary">
                {`${label}: `}
            </Text>
            <Text as="span" textStyle="body-s">
                {value}
            </Text>
        </Text>
    );
}
